import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material"
import { useState } from "react";

const pickerPaperSx = {
    '& .MuiPickersCalendarHeader-label': { fontSize: 13 },
    '& .MuiDayPicker-weekDayLabel': { fontSize: 11 },
    '& .MuiPickersDay-root': { fontSize: 12 },
    '& .MuiPickersYear-yearButton': { fontSize: 12 },
    '& .MuiMonthPicker-root .MuiTypography-root': { fontSize: 12 },
    '& .PrivatePickersMonth-root': { fontSize: 12 },
    '& .MuiPickersArrowSwitcher-button': { padding: '4px' },
};

export default function DateField({ onChange, size, ...other }) {
    const [value, setValue] = useState(new Date())
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={value}
                onChange={(v) => {
                    setValue(v)
                    if (onChange instanceof Function)
                        onChange(v)
                }}
                PaperProps={{ sx: pickerPaperSx }}
                {...other}
                renderInput={(params) => <TextField
                    label="From Date"
                    fullWidth
                    variant="filled"
                    size={size}
                    {...params}
                />}
            />
        </LocalizationProvider>
    )
}
